module.exports = __webpack_public_path__ + "static/media/iso.7583c4b4.png";